import URI from 'urijs';

// this method only exists for testing purposes because on test executiong
// there is a typescript error saying that urijs.default is not a constructor
export const createURIObject = (url: string) => {
    return new URI(url);
};
